import { render, staticRenderFns } from "./DadosPessoais.vue?vue&type=template&id=3fc6d15b&scoped=true"
import script from "./DadosPessoais.vue?vue&type=script&lang=js"
export * from "./DadosPessoais.vue?vue&type=script&lang=js"
import style0 from "./DadosPessoais.vue?vue&type=style&index=0&id=3fc6d15b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6d15b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
